import ky from 'ky';

const placesBaseUrl = (process.env.NEXT_PUBLIC_GG_PLACES_URL || 'https://places.googleapis.com/v1').replace(/\/$/, '');

export const placesKyClient = ky.create({
  prefixUrl: `${placesBaseUrl}/`,
  hooks: {
    beforeRequest: [
      (request) => {
        const apiKey = process.env.NEXT_PUBLIC_GG_PLACES_KEY;
        if (apiKey) {
          request.headers.set('X-Goog-Api-Key', apiKey);
        }
      },
    ],
  },
});
